var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cityface"},[_c('div',{attrs:{"id":"canvas"}}),_vm._v(" "),(_vm.$store.state.route.path === '/copenhagen')?_c('div',{staticClass:"cityface__loader"}):_c('div',{staticClass:"cityface__sticker"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cfccb44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityFace.vue
// module id = 574
// module chunks = 3